import React, { Children, cloneElement, isValidElement } from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';

const bem = new BEMHelper('RadioButtonGroup');

const propTypes = {
    value: PropTypes.any,
    className: PropTypes.string,
    divided: PropTypes.bool,
    removeFirstDivider: PropTypes.bool,
    children: PropTypes.node,
    removeLastDivider: PropTypes.bool,
};

const defaultValues = {
    divided: false,
    removeFirstDivider: false,
    removeLastDivider: false,
};

function RadioButtonGroup(props) {
    const { children, className, divided, id, removeFirstDivider, removeLastDivider, value, ...rest } = props;

    return (
        <div className={bem(null, { divided, removeFirstDivider, removeLastDivider }, className)}>
            {Children.map(children, (child, i) => {
                if (isValidElement(child)) {
                    return cloneElement(child, {
                        id: id ? `${id}${i}` : undefined,
                        checked: child.props.value === value,
                        ...rest,
                    });
                }

                return child;
            })}
        </div>
    );
}

RadioButtonGroup.propTypes = propTypes;
RadioButtonGroup.defaultProps = defaultValues;

export default RadioButtonGroup;
